import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkSyncModelRequest = {};
var _bulkSyncModelResponse = { models: '_extended' };
var _createModelRequest = {};
var _createModelResponse = {};
var _deleteModelRequest = {};
var _deleteModelResponse = {};
var _exportDataRequest = {};
var _exportDataResponse = {};
var _extended = {
    createdAt: 'google.protobuf.Timestamp',
    updatedAt: 'google.protobuf.Timestamp',
    syncedAt: 'google.protobuf.Timestamp',
};
var _formatModelFieldValuesRequest = {};
var _formatModelFieldValuesResponse = {};
var _getExtendedModelRequest = {};
var _getExtendedModelResponse = { model: '_extended' };
var _getExtendedModelVersionsRequest = {};
var _getExtendedModelVersionsResponse = { models: '_extended' };
var _getModelDataRequest = {};
var _getModelDataResponse = {};
var _getModelFieldValuesRequest = {};
var _getModelFieldValuesResponse = {};
var _getModelRequest = {};
var _getModelResponse = {};
var _getModelsRequest = {};
var _getModelsResponse = {};
var _getModelTotalsRequest = {};
var _getModelTotalsResponse = {};
var _switchEnvVersionRequest = {};
var _switchEnvVersionResponse = {};
var _syncModelRequest = {};
var _syncModelResponse = { model: '_extended' };
var _updateModelRequest = {};
var _updateModelResponse = { model: '_extended' };
function resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/analytics/reports-api',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/analytics/reports-api',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/analytics/reports-api',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/analytics/reports-api',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Create model from external source
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.CreateModel(), and will be removed on 2025-06-01.
 */
export function createModel(payload) {
    var _a = serializer(_createModelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createModelResponse, {}).fromJSON;
    function __createModel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.CreateModel',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createModel.fromReq = fromReq;
    __createModel.__isAmbassador = true;
    return __createModel;
}
/**
 * Get model
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.GetModel(), and will be removed on 2025-06-01.
 */
export function getModel(payload) {
    var _a = serializer(_getModelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getModelResponse, {}).fromJSON;
    function __getModel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.GetModel',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/get',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getModel.fromReq = fromReq;
    __getModel.__isAmbassador = true;
    return __getModel;
}
/**
 * Get extended model
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.GetExtendedModel(), and will be removed on 2025-06-01.
 */
export function getExtendedModel(payload) {
    var _a = serializer(_getExtendedModelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getExtendedModelResponse, {
        _extended: _extended,
    }).fromJSON;
    function __getExtendedModel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.GetExtendedModel',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/get-extended',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getExtendedModel.fromReq = fromReq;
    __getExtendedModel.__isAmbassador = true;
    return __getExtendedModel;
}
/**
 * Get extended model versions
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.GetExtendedModelVersions(), and will be removed on 2025-06-01.
 */
export function getExtendedModelVersions(payload) {
    var _a = serializer(_getExtendedModelVersionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getExtendedModelVersionsResponse, {
        _extended: _extended,
    }).fromJSON;
    function __getExtendedModelVersions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.GetExtendedModelVersions',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/get-extended-versions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getExtendedModelVersions.fromReq = fromReq;
    __getExtendedModelVersions.__isAmbassador = true;
    return __getExtendedModelVersions;
}
/**
 * Get field values
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.GetModelFieldValues(), and will be removed on 2025-06-01.
 */
export function getModelFieldValues(payload) {
    var _a = serializer(_getModelFieldValuesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getModelFieldValuesResponse, {}).fromJSON;
    function __getModelFieldValues(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.GetModelFieldValues',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/fields/get-values',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getModelFieldValues.fromReq = fromReq;
    __getModelFieldValues.__isAmbassador = true;
    return __getModelFieldValues;
}
/**
 * Format filter values
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.FormatModelFieldValues(), and will be removed on 2025-06-01.
 */
export function formatModelFieldValues(payload) {
    var _a = serializer(_formatModelFieldValuesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_formatModelFieldValuesResponse, {}).fromJSON;
    function __formatModelFieldValues(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.FormatModelFieldValues',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/fields/format-filters',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __formatModelFieldValues.fromReq = fromReq;
    __formatModelFieldValues.__isAmbassador = true;
    return __formatModelFieldValues;
}
/**
 * Sync model with external source
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.SyncModel(), and will be removed on 2025-06-01.
 */
export function syncModel(payload) {
    var _a = serializer(_syncModelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_syncModelResponse, { _extended: _extended }).fromJSON;
    function __syncModel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.SyncModel',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/sync',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __syncModel.fromReq = fromReq;
    __syncModel.__isAmbassador = true;
    return __syncModel;
}
/**
 * Bulk sync model with external source
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.BulkSyncModel(), and will be removed on 2025-06-01.
 */
export function bulkSyncModel(payload) {
    var _a = serializer(_bulkSyncModelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkSyncModelResponse, {
        _extended: _extended,
    }).fromJSON;
    function __bulkSyncModel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.BulkSyncModel',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/sync-bulk',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkSyncModel.fromReq = fromReq;
    __bulkSyncModel.__isAmbassador = true;
    return __bulkSyncModel;
}
/**
 * Update model settings
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.UpdateModel(), and will be removed on 2025-06-01.
 */
export function updateModel(payload) {
    var _a = serializer(_updateModelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateModelResponse, { _extended: _extended }).fromJSON;
    function __updateModel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.UpdateModel',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateModel.fromReq = fromReq;
    __updateModel.__isAmbassador = true;
    return __updateModel;
}
/**
 * Update model settings
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.SwitchEnvVersion(), and will be removed on 2025-06-01.
 */
export function switchEnvVersion(payload) {
    var _a = serializer(_switchEnvVersionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_switchEnvVersionResponse, {}).fromJSON;
    function __switchEnvVersion(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.SwitchEnvVersion',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/env-update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __switchEnvVersion.fromReq = fromReq;
    __switchEnvVersion.__isAmbassador = true;
    return __switchEnvVersion;
}
/**
 * Get all models
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.GetModels(), and will be removed on 2025-06-01.
 */
export function getModels(payload) {
    var _a = serializer(_getModelsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getModelsResponse, {}).fromJSON;
    function __getModels(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.GetModels',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/get-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getModels.fromReq = fromReq;
    __getModels.__isAmbassador = true;
    return __getModels;
}
/**
 * Get model data.
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.GetModelData(), and will be removed on 2025-06-01.
 */
export function getModelData(payload) {
    var _a = serializer(_getModelDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getModelDataResponse, {}).fromJSON;
    function __getModelData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.GetModelData',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/get-data',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getModelData.fromReq = fromReq;
    __getModelData.__isAmbassador = true;
    return __getModelData;
}
/**
 * Get model totals data.
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.GetModelTotals(), and will be removed on 2025-06-01.
 */
export function getModelTotals(payload) {
    var _a = serializer(_getModelTotalsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getModelTotalsResponse, {}).fromJSON;
    function __getModelTotals(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.GetModelTotals',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/get-totals',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getModelTotals.fromReq = fromReq;
    __getModelTotals.__isAmbassador = true;
    return __getModelTotals;
}
/**
 * Delete model
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.DeleteModel(), and will be removed on 2025-06-01.
 */
export function deleteModel(payload) {
    var _a = serializer(_deleteModelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteModelResponse, {}).fromJSON;
    function __deleteModel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.DeleteModel',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteModel.fromReq = fromReq;
    __deleteModel.__isAmbassador = true;
    return __deleteModel;
}
/**
 * Get export file link.
 * @deprecated It has been replaced with wix.analytics_ng_reports.model.v2.ModelsService.ExportData(), and will be removed on 2025-06-01.
 */
export function exportData(payload) {
    var _a = serializer(_exportDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_exportDataResponse, {}).fromJSON;
    function __exportData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.analytics_ng_reports.model.v1.model',
            method: 'POST',
            methodFqn: 'wix.analytics_ng_reports.model.v1.ModelsService.ExportData',
            url: resolveWixAnalyticsNgReportsModelV1ModelsServiceUrl({
                protoPath: '/v1/models/export',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __exportData.fromReq = fromReq;
    __exportData.__isAmbassador = true;
    return __exportData;
}
//# sourceMappingURL=http.impl.js.map